import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import { TDBMRule, TLogicRule } from "./Components/RuleComponents/dataTypes";
import { DBM_RULE_TYPE } from "./ISRConstants";

let api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const getRuleList = async (project_id:string, limit:number = 1000) => {
  try {
    let res = await ServiceWrapper.doGet(
      `${api_base_url}isr/rules/${project_id}?limit=${limit}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
};

/** One field's DBM rules — DBM is a field rule; the unfiltered list above excludes it. */
export const getFieldDBMRules = async (project_id:string, field_id:string, limit:number = 1000) => {
  try {
    let res = await ServiceWrapper.doGet(
      `${api_base_url}isr/rules/${project_id}?rule_type=${DBM_RULE_TYPE}&field=${encodeURIComponent(field_id)}&limit=${limit}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getRuleItem = async (rule_id:string) => {
  try {
    let res = await ServiceWrapper.doGet(
      `${api_base_url}isr/rule/${rule_id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const saveRule = async (requestBody:TLogicRule | TDBMRule) => {
  try {
    let res = await ServiceWrapper.doPost(
      `${api_base_url}isr/rule/create`,
      requestBody,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }

};

export const updateRule = async (requestBody:TLogicRule | TDBMRule) => {
  try {
    let res = await ServiceWrapper.doPut(
      `${api_base_url}isr/rule/update`,
      requestBody,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteRule = async (rule_id:string) => {
  try {
    const res = await ServiceWrapper.doDelete(
      `${api_base_url}isr/rule/delete/${rule_id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res?.data?.done) return true
  } catch (error) {
     return false
  }
}
